'use client';
import React, { useState } from 'react';
import { Tab } from '../types/type';
import Link from 'next/link';
import ProductCard from '@/features/product-card/components/productCard';
import products from '../../../../public/json/popular-product.json';

const PopularProducts = () => {
  const [activeTab, setActiveTab] = useState('All');
  const tabs: Tab[] = [
    { id: 'pills-all-tab', label: 'All' },
    { id: 'pills-new-arrivals-tab', label: 'New arrivals' },
    { id: 'pills-features-tab', label: 'Features' },
    { id: 'pills-best-sellers-tab', label: 'Best sellers' },
  ];

  // ✅ FIX: Compute filtered products directly in the render to avoid useEffect-based updates
  const FilterProduct = products
    ? products.filter((p: any) =>
        activeTab === 'All' ? true : p.categories === activeTab
      )
    : [];

  return (
    <section className="popular-product">
      <div className="container">
        <div
          className="popular-product__wrapper"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="popular-product__header section-header">
            <h2 className="popular-product__title order-sm-1">
              Popular Products
            </h2>
            <div className="popular-product__filters order-sm-3 order-lg-2">
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                {tabs.map((tab, i: number) => (
                  <li className="nav-item" role="presentation" key={i}>
                    <button
                      className={`nav-link ${activeTab === tab.label ? 'active' : ''}`}
                      id={tab.id}
                      type="button"
                      role="tab"
                      // ✅ FIX: Ensure aria-selected is explicitly a boolean
                      aria-selected={activeTab === tab.label ? true : false}
                      onClick={() => setActiveTab(tab.label)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="product-btn order-sm-2 order-lg-3">
              <Link className="trk-btn trk-btn--sm" href="/flash-sale">
                View all
              </Link>
            </div>
          </div>
          <div className="tab-content" id="pills-tabContent">
            <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 justify-content-center g-3">
              {FilterProduct.length > 0 ? (
                FilterProduct.map((data: any, i: number) => (
                  <div className="col" key={i}>
                    <ProductCard data={data} />
                  </div>
                ))
              ) : (
                <p className="text-center">No products available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularProducts;
